import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 7,
  class: "payments-page-wrapper-nspk"
}
const _hoisted_2 = {
  key: 0,
  class: "main-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "main-container"
}
const _hoisted_5 = {
  key: 2,
  class: "main-container"
}
const _hoisted_6 = {
  key: 8,
  class: "payments-page-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "alfa-notice-overlay",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "alfa-notice-title"
}
const _hoisted_8 = { class: "alfa-notice-modal" }
const _hoisted_9 = {
  class: "alfa-notice-title",
  id: "alfa-notice-title"
}
const _hoisted_10 = { class: "alfa-notice-amount" }
const _hoisted_11 = { class: "alfa-notice-amount-label" }
const _hoisted_12 = { class: "alfa-notice-amount-value" }
const _hoisted_13 = { class: "alfa-notice-list" }
const _hoisted_14 = { class: "alfa-notice-emphasis" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "payments-page__title" }
const _hoisted_17 = {
  key: 0,
  class: "brand-logo"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "payments-page__subtitle order-number"
}
const _hoisted_21 = {
  key: 0,
  class: "payments-page__content payments-page__content--payment"
}
const _hoisted_22 = { class: "payments-page__instruction" }
const _hoisted_23 = { class: "payments-page__payments-block payments-block" }
const _hoisted_24 = { class: "payments-block__top replenishment" }
const _hoisted_25 = { class: "replenishment__title" }
const _hoisted_26 = { class: "replenishment__sum" }
const _hoisted_27 = { class: "payments-page__transaction-field" }
const _hoisted_28 = { class: "transaction-field" }
const _hoisted_29 = { class: "transaction-field__label" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = {
  key: 0,
  class: "transaction-field__error"
}
const _hoisted_32 = { class: "payments-page__controls" }
const _hoisted_33 = {
  key: 1,
  class: "payments-page__content payments-page__content--payment"
}
const _hoisted_34 = { class: "payments-page__instruction desktop" }
const _hoisted_35 = { class: "payments-page__instruction mobile" }
const _hoisted_36 = { class: "payments-page__payments-block payments-block" }
const _hoisted_37 = { class: "payments-block__top replenishment" }
const _hoisted_38 = { class: "replenishment__title" }
const _hoisted_39 = { class: "replenishment__sum" }
const _hoisted_40 = { class: "for-copy" }
const _hoisted_41 = {
  key: 0,
  class: "replenishment__commission-notice"
}
const _hoisted_42 = {
  key: 1,
  class: "replenishment__tjs-notice"
}
const _hoisted_43 = { class: "replenishment__tjs-notice-title" }
const _hoisted_44 = { class: "replenishment__tjs-notice-amount" }
const _hoisted_45 = {
  key: 2,
  class: "replenishment__timer"
}
const _hoisted_46 = { class: "replenishment__timer" }
const _hoisted_47 = { class: "replenishment__timer-visual" }
const _hoisted_48 = { class: "timer" }
const _hoisted_49 = { class: "replenishment__timer-text" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 2,
  class: "payments-block__info"
}
const _hoisted_52 = {
  class: "payments-block__text",
  style: {"display":"flex","flex-direction":"column","width":"100%"}
}
const _hoisted_53 = { style: {"display":"flex","align-items":"center","justify-content":"center","gap":"0.5rem","margin-bottom":"0.5rem"} }
const _hoisted_54 = { style: {"padding":"0","margin":"0"} }
const _hoisted_55 = { style: {"list-style-type":"decimal","margin":"0","line-height":"130%","padding-left":"20px"} }
const _hoisted_56 = { style: {"font-weight":"500"} }
const _hoisted_57 = {
  key: 3,
  class: "payments-block__tbank-warning"
}
const _hoisted_58 = { class: "payments-block__tbank-warning-header" }
const _hoisted_59 = { class: "payments-block__tbank-warning-text" }
const _hoisted_60 = {
  key: 4,
  class: "payments-block__warning"
}
const _hoisted_61 = {
  class: "payments-block__text",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_62 = { style: {"display":"flex","align-items":"center","justify-content":"center","gap":"0.5rem","margin-bottom":"0.5rem"} }
const _hoisted_63 = { style: {"padding":"0","margin":"0"} }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { style: {"list-style-type":"decimal","margin":"0","line-height":"130%","padding-left":"20px"} }
const _hoisted_66 = { style: {"font-weight":"500"} }
const _hoisted_67 = { style: {"font-weight":"500"} }
const _hoisted_68 = { style: {"font-weight":"bold","text-transform":"uppercase","color":"var(--attention)","text-align":"center"} }
const _hoisted_69 = {
  key: 0,
  class: "payments-block__warning"
}
const _hoisted_70 = {
  class: "payments-block__text",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_71 = { style: {"display":"flex","align-items":"center","justify-content":"center","gap":"0.5rem","margin-bottom":"0.5rem"} }
const _hoisted_72 = { style: {"padding":"0","margin":"0"} }
const _hoisted_73 = { style: {"font-weight":"500","line-height":"130%"} }
const _hoisted_74 = { style: {"font-weight":"bold","text-transform":"uppercase","color":"var(--attention)","text-align":"center","margin-top":"0.5rem"} }
const _hoisted_75 = {
  key: 1,
  class: "payments-page__receipt"
}
const _hoisted_76 = { class: "download-form__text" }
const _hoisted_77 = {
  key: 1,
  class: "download-form__container download-form__container--payments",
  style: {"display":"flex","align-items":"center","justify-content":"space-between","gap":"0.5rem"}
}
const _hoisted_78 = { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_79 = {
  key: 2,
  class: "transaction-field__error",
  style: {"display":"block","text-align":"center","margin-top":"0.5rem"}
}
const _hoisted_80 = {
  key: 2,
  class: "payments-page__transaction-field"
}
const _hoisted_81 = { class: "transaction-field" }
const _hoisted_82 = { class: "transaction-field__label" }
const _hoisted_83 = ["placeholder"]
const _hoisted_84 = {
  key: 0,
  class: "transaction-field__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PSBCrossBorderPage = _resolveComponent("PSBCrossBorderPage")!
  const _component_AlfaCrossBorderPage = _resolveComponent("AlfaCrossBorderPage")!
  const _component_AlfaC2cCrossBorderPage = _resolveComponent("AlfaC2cCrossBorderPage")!
  const _component_VaslTransferPage = _resolveComponent("VaslTransferPage")!
  const _component_KazakhstanCrossBorderPage = _resolveComponent("KazakhstanCrossBorderPage")!
  const _component_TPayMatching = _resolveComponent("TPayMatching")!
  const _component_PayButtonsPage = _resolveComponent("PayButtonsPage")!
  const _component_SBPQRPaymentDetails = _resolveComponent("SBPQRPaymentDetails")!
  const _component_ClickQRPaymentDetails = _resolveComponent("ClickQRPaymentDetails")!
  const _component_ToBankDetailsPaymentDetails = _resolveComponent("ToBankDetailsPaymentDetails")!
  const _component_BankPayButtonPaymentDetails = _resolveComponent("BankPayButtonPaymentDetails")!
  const _component_DefaultPaymentDetails = _resolveComponent("DefaultPaymentDetails")!
  const _component_AcquiringPaymentDetails = _resolveComponent("AcquiringPaymentDetails")!
  const _component_InvoiceStateInfo = _resolveComponent("InvoiceStateInfo")!

  return (_ctx.paymentPageLayout === 'psb_cross_border' && _ctx.psbCrossBorderDeal)
    ? (_openBlock(), _createBlock(_component_PSBCrossBorderPage, {
        key: 0,
        "current-deal": _ctx.psbCrossBorderDeal,
        invoice: _ctx.invoice,
        cancelDeal: _ctx.cancelDeal,
        confirmTransfer: _ctx.confirmTransfer,
        transactionId: _ctx.transactionId,
        "onUpdate:transactionId": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transactionId) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.transactionIdError = ''))
        ],
        transactionIdError: _ctx.transactionIdError
      }, null, 8, ["current-deal", "invoice", "cancelDeal", "confirmTransfer", "transactionId", "transactionIdError"]))
    : (_ctx.paymentPageLayout === 'alfa_cross_border' && _ctx.alfaCrossBorderDeal)
      ? (_openBlock(), _createBlock(_component_AlfaCrossBorderPage, {
          key: 1,
          "current-deal": _ctx.alfaCrossBorderDeal,
          invoice: _ctx.invoice,
          cancelDeal: _ctx.cancelDeal,
          confirmTransfer: _ctx.confirmTransfer
        }, null, 8, ["current-deal", "invoice", "cancelDeal", "confirmTransfer"]))
      : (_ctx.paymentPageLayout === 'alfa_c2c_cross_border' && _ctx.alfaC2cCrossBorderDeal)
        ? (_openBlock(), _createBlock(_component_AlfaC2cCrossBorderPage, {
            key: 2,
            "current-deal": _ctx.alfaC2cCrossBorderDeal,
            invoice: _ctx.invoice,
            cancelDeal: _ctx.cancelDeal,
            confirmTransfer: _ctx.confirmTransfer
          }, null, 8, ["current-deal", "invoice", "cancelDeal", "confirmTransfer"]))
        : (_ctx.vaslTransferBank && _ctx.vaslTransferDeal)
          ? (_openBlock(), _createBlock(_component_VaslTransferPage, {
              key: 3,
              bank: _ctx.vaslTransferBank,
              "current-deal": _ctx.vaslTransferDeal,
              invoice: _ctx.invoice,
              cancelDeal: _ctx.cancelDeal,
              confirmTransfer: _ctx.confirmTransfer,
              transactionId: _ctx.transactionId,
              "onUpdate:transactionId": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.transactionId) = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (_ctx.transactionIdError = ''))
              ],
              transactionIdError: _ctx.transactionIdError
            }, null, 8, ["bank", "current-deal", "invoice", "cancelDeal", "confirmTransfer", "transactionId", "transactionIdError"]))
          : (_ctx.paymentPageLayout === 'kazakhstan_cross_border' && _ctx.kazakhstanCrossBorderDeal)
            ? (_openBlock(), _createBlock(_component_KazakhstanCrossBorderPage, {
                key: 4,
                "current-deal": _ctx.kazakhstanCrossBorderDeal,
                invoice: _ctx.invoice,
                cancelDeal: _ctx.cancelDeal,
                confirmTransfer: _ctx.confirmTransfer,
                transactionId: _ctx.transactionId,
                "onUpdate:transactionId": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.transactionId) = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.transactionIdError = ''))
                ],
                transactionIdError: _ctx.transactionIdError
              }, null, 8, ["current-deal", "invoice", "cancelDeal", "confirmTransfer", "transactionId", "transactionIdError"]))
            : (_ctx.paymentPageLayout === 'seq')
              ? (_openBlock(), _createBlock(_component_TPayMatching, {
                  key: 5,
                  "current-deal": _ctx.currentDeal,
                  waitingForRequisites: _ctx.waitingForRequisites,
                  invoice: _ctx.invoice,
                  cancelDeal: _ctx.cancelDeal,
                  confirmTransfer: _ctx.confirmTransfer
                }, null, 8, ["current-deal", "waitingForRequisites", "invoice", "cancelDeal", "confirmTransfer"]))
              : (_ctx.paymentPageLayout === 'pay_buttons')
                ? (_openBlock(), _createBlock(_component_PayButtonsPage, {
                    key: 6,
                    invoice: _ctx.invoice
                  }, null, 8, ["invoice"]))
                : (_ctx.flowType === _ctx.FlowType.NSPK)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (_ctx.waitingForRequisites || _ctx.currentDeal?.status === _ctx.DealStatus.TRANSFER_WAITING)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "main-text" }, "Внимание!", -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "sub-text" }, "Формируется ссылка на оплату, пожалуйста ожидайте", -1)),
                            _createElementVNode("img", {
                              style: {"height":"2rem"},
                              src: require('@/assets/img/90-ring-with-bg.svg')
                            }, null, 8, _hoisted_3)
                          ]))
                        : (_ctx.currentDeal === null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[20] || (_cache[20] = [
                              _createElementVNode("div", { class: "sub-text" }, "Сейчас нет доступных методов оплаты, попробуйте позже.", -1)
                            ])))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[21] || (_cache[21] = [
                              _createElementVNode("div", { class: "sub-text" }, "Платеж отменен", -1)
                            ])))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_ctx.alfaTjsSum && !_ctx.alfaNoticeDismissed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('alfa-pay-tjs.title')), 1),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('alfa-pay-tjs.min-label')), 1),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.alfaTjsAmountText), 1)
                              ]),
                              _createElementVNode("ul", _hoisted_13, [
                                _createElementVNode("li", null, _toDisplayString(_ctx.$t('alfa-pay-tjs.line-1')), 1),
                                _createElementVNode("li", null, _toDisplayString(_ctx.$t('alfa-pay-tjs.line-2')), 1),
                                _createElementVNode("li", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('alfa-pay-tjs.line-3')) + " ", 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('alfa-pay-tjs.line-3-emphasis')), 1)
                                ])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "alfa-notice-btn",
                                disabled: _ctx.alfaNoticeSecondsLeft > 0,
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dismissAlfaNotice && _ctx.dismissAlfaNotice(...args)))
                              }, _toDisplayString(_ctx.alfaNoticeSecondsLeft > 0
            ? _ctx.$t('alfa-pay-tjs.wait', {seconds: _ctx.alfaNoticeSecondsLeft})
            : _ctx.$t('alfa-pay-tjs.ok')), 9, _hoisted_15)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.invoice)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["payments-page", _ctx.brandClasses])
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", null, [
                                (_ctx.brand)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createElementVNode("img", {
                                        src: `/img/logo/${_ctx.brand}-on-light.png`,
                                        class: "logo__light"
                                      }, null, 8, _hoisted_18),
                                      _createElementVNode("img", {
                                        src: `/img/logo/${_ctx.brand}-on-dark.png`,
                                        class: "logo__dark"
                                      }, null, 8, _hoisted_19)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.title)) + " ", 1),
                                (_ctx.invoice.internalId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('invoice.order', {id: _ctx.invoice.internalId})), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (_ctx.showUserPhoneForm)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('invoice.user-phone-instruction')), 1),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('invoice.transfer-sum')), 1),
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatMoney(Number(_ctx.invoice.sum.amount), _ctx.invoice.sum.currency)), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("label", _hoisted_29, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('invoice.user-phone-label')) + " ", 1),
                                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "transaction-field__required" }, "*", -1))
                                      ]),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userPhone) = $event)),
                                        type: "tel",
                                        inputmode: "tel",
                                        class: _normalizeClass(["transaction-field__input", {'transaction-field__input--error': _ctx.userPhoneError}]),
                                        placeholder: _ctx.$t('invoice.user-phone-placeholder'),
                                        onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onUserPhoneInput && _ctx.onUserPhoneInput(...args)))
                                      }, null, 42, _hoisted_30), [
                                        [_vModelText, _ctx.userPhone]
                                      ]),
                                      (_ctx.userPhoneError)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.userPhoneError), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_32, [
                                    (!_ctx.receiptPdfRequired)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "btn payments-page__close",
                                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
                                        }, _toDisplayString(_ctx.$t('invoice.return-to-merchant')), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      class: "btn btn--accept",
                                      type: "button",
                                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitUserPhone && _ctx.submitUserPhone(...args)), ["prevent"]))
                                    }, _toDisplayString(_ctx.$t('invoice.user-phone-submit')), 1)
                                  ])
                                ]))
                              : (_ctx.shouldShowPaymentBlock)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t(_ctx.transferTextDesktop)), 1),
                                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t(_ctx.transferTextMobile)), 1),
                                    _createElementVNode("div", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('invoice.transfer-sum')), 1),
                                        _createElementVNode("div", _hoisted_39, [
                                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.numberFormatter.formatMoney(Number(_ctx.paymentSum.amount), _ctx.paymentSum.currency)), 1),
                                          (_ctx.showAmountCopyButton)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "copy-link",
                                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, _ctx.paymentSum.amount)), ["prevent"]))
                                              }, _cache[23] || (_cache[23] = [
                                                _createElementVNode("svg", {
                                                  width: "20",
                                                  height: "20",
                                                  viewBox: "0 0 20 20",
                                                  xmlns: "http://www.w3.org/2000/svg"
                                                }, [
                                                  _createElementVNode("path", { d: "M6.99994 3.49991C6.99994 3.10208 7.15797 2.72055 7.43928 2.43925C7.72058 2.15794 8.10211 1.99991 8.49994 1.99991H12.3789C12.7766 2.00026 13.1579 2.15852 13.4389 2.43991L16.5609 5.55991C16.7003 5.69938 16.8108 5.86497 16.8862 6.0472C16.9615 6.22943 17.0002 6.42472 16.9999 6.62191V12.4999C16.9999 12.8977 16.8419 13.2793 16.5606 13.5606C16.2793 13.8419 15.8978 13.9999 15.4999 13.9999H14.4999V10.6209C14.4998 9.82532 14.1836 9.06239 13.6209 8.49991L10.4999 5.37891C9.93746 4.81626 9.17452 4.50008 8.37894 4.49991H6.99994V3.49991Z" }),
                                                  _createElementVNode("path", { d: "M4.50006 5.99997C4.10224 5.99997 3.72071 6.15801 3.4394 6.43931C3.1581 6.72061 3.00006 7.10215 3.00006 7.49997V16.5C3.00006 16.8978 3.1581 17.2793 3.4394 17.5606C3.72071 17.8419 4.10224 18 4.50006 18H11.5001C11.8979 18 12.2794 17.8419 12.5607 17.5606C12.842 17.2793 13.0001 16.8978 13.0001 16.5V10.621C12.9997 10.2233 12.8414 9.84201 12.5601 9.56097L9.44006 6.43897C9.30059 6.29958 9.135 6.18907 8.95277 6.11374C8.77054 6.03841 8.57525 5.99975 8.37806 5.99997H4.50006Z" })
                                                ], -1)
                                              ])))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.flowType === _ctx.FlowType.VIET_QR)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.$t('invoice.viet-qr-commission-notice')), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.alfaTjsSum)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('alfa-pay-tjs.check-title')), 1),
                                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('alfa-pay-tjs.receive-label')) + " " + _toDisplayString(_ctx.$t('alfa-pay-tjs.receive-value', {amount: _ctx.alfaTjsAmountText})), 1),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('alfa-pay-tjs.short')), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.currentDeal)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                              _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, [
                                                  _createElementVNode("div", _hoisted_48, [
                                                    _createElementVNode("div", {
                                                      class: "timer__line",
                                                      style: _normalizeStyle({'width': _ctx.getTimeToPayPercent(_ctx.currentDeal) + '%'})
                                                    }, null, 4)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_49, [
                                                  _cache[24] || (_cache[24] = _createElementVNode("svg", {
                                                    width: "21",
                                                    height: "20",
                                                    viewBox: "0 0 21 20",
                                                    fill: "#00A3FB",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }, [
                                                    _createElementVNode("path", {
                                                      "fill-rule": "evenodd",
                                                      "clip-rule": "evenodd",
                                                      d: "M10.5 18C12.6217 18 14.6566 17.1571 16.1569 15.6569C17.6571 14.1566 18.5 12.1217 18.5 10C18.5 7.87827 17.6571 5.84344 16.1569 4.34315C14.6566 2.84285 12.6217 2 10.5 2C8.37827 2 6.34344 2.84285 4.84315 4.34315C3.34285 5.84344 2.5 7.87827 2.5 10C2.5 12.1217 3.34285 14.1566 4.84315 15.6569C6.34344 17.1571 8.37827 18 10.5 18ZM11.25 5C11.25 4.80109 11.171 4.61032 11.0303 4.46967C10.8897 4.32902 10.6989 4.25 10.5 4.25C10.3011 4.25 10.1103 4.32902 9.96967 4.46967C9.82902 4.61032 9.75 4.80109 9.75 5V10C9.75 10.414 10.086 10.75 10.5 10.75H14.5C14.6989 10.75 14.8897 10.671 15.0303 10.5303C15.171 10.3897 15.25 10.1989 15.25 10C15.25 9.80109 15.171 9.61032 15.0303 9.46967C14.8897 9.32902 14.6989 9.25 14.5 9.25H11.25V5Z"
                                                    })
                                                  ], -1)),
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('invoice.time-to-pay')) + " ", 1),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.formatCancelTime(_ctx.currentDeal)), 1)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.currentDeal)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            (_ctx.showSbpQrPaymentDetails)
                                              ? (_openBlock(), _createBlock(_component_SBPQRPaymentDetails, {
                                                  key: 0,
                                                  invoice: _ctx.invoice,
                                                  deal: _ctx.currentDeal
                                                }, null, 8, ["invoice", "deal"]))
                                              : (_ctx.flowType === _ctx.FlowType.CLICK_QR)
                                                ? (_openBlock(), _createBlock(_component_ClickQRPaymentDetails, {
                                                    key: 1,
                                                    invoice: _ctx.invoice,
                                                    deal: _ctx.currentDeal
                                                  }, null, 8, ["invoice", "deal"]))
                                                : (_ctx.flowType === _ctx.FlowType.VIET_QR || _ctx.flowType === _ctx.FlowType.IND_QR || _ctx.flowType === _ctx.FlowType.BR_QR || _ctx.flowType === _ctx.FlowType.TO_BANK_DETAILS)
                                                  ? (_openBlock(), _createBlock(_component_ToBankDetailsPaymentDetails, {
                                                      key: 2,
                                                      invoice: _ctx.invoice,
                                                      deal: _ctx.currentDeal
                                                    }, null, 8, ["invoice", "deal"]))
                                                  : (_ctx.isBankPayFlow(_ctx.flowType))
                                                    ? (_openBlock(), _createBlock(_component_BankPayButtonPaymentDetails, {
                                                        key: 3,
                                                        invoice: _ctx.invoice,
                                                        flow: _ctx.flowType,
                                                        deal: _ctx.currentDeal
                                                      }, null, 8, ["invoice", "flow", "deal"]))
                                                    : (_ctx.flowType !== _ctx.FlowType.CARD_ACQUIRING_REDIRECT)
                                                      ? (_openBlock(), _createBlock(_component_DefaultPaymentDetails, {
                                                          key: 4,
                                                          invoice: _ctx.invoice,
                                                          currentDeal: _ctx.currentDeal
                                                        }, null, 8, ["invoice", "currentDeal"]))
                                                      : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.flowType === _ctx.FlowType.CARD_ACQUIRING || _ctx.flowType === _ctx.FlowType.MANUAL_ECOM || _ctx.flowType === _ctx.FlowType.CARD_ACQUIRING_REDIRECT)
                                        ? (_openBlock(), _createBlock(_component_AcquiringPaymentDetails, {
                                            key: 1,
                                            invoice: _ctx.invoice,
                                            currentDeal: _ctx.currentDeal,
                                            paymentOption: _ctx.flowType,
                                            "onDeal:created": _ctx.handleDealCreated,
                                            "on3ds:submitted": _ctx.handle3dsSubmitted
                                          }, null, 8, ["invoice", "currentDeal", "paymentOption", "onDeal:created", "on3ds:submitted"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.currentDeal && _ctx.invoice && _ctx.invoice.flowData && _ctx.invoice.flowData.instructions)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _createElementVNode("div", _hoisted_53, [
                                                _cache[25] || (_cache[25] = _createElementVNode("div", {
                                                  class: "payments-block__icon",
                                                  style: {"display":"flex"}
                                                }, [
                                                  _createElementVNode("svg", {
                                                    width: "26",
                                                    height: "24",
                                                    viewBox: "2 2 20 20",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }, [
                                                    _createElementVNode("path", {
                                                      d: "M12 2C6.4898 2 2 6.4898 2 12C2 17.5102 6.4898 22 12 22C17.5102 22 22 17.5102 22 12C22 6.4898 17.5102 2 12 2ZM12.8163 15.5714C12.8163 15.9796 12.5102 16.3878 12 16.3878C11.4898 16.3878 11.1837 16.0816 11.1837 15.5714V11.4898C11.1837 11.0816 11.4898 10.6735 12 10.6735C12.5102 10.6735 12.8163 10.9796 12.8163 11.4898V15.5714ZM12 9.44898C11.4898 9.44898 10.9796 8.93878 10.9796 8.42857C10.9796 7.91837 11.4898 7.40816 12 7.40816C12.5102 7.40816 13.0204 7.91837 13.0204 8.42857C13.0204 8.93878 12.5102 9.44898 12 9.44898Z",
                                                      fill: "#00A3FB"
                                                    })
                                                  ])
                                                ], -1)),
                                                _createElementVNode("h3", _hoisted_54, _toDisplayString(_ctx.$t('invoice.how-to-pay')), 1)
                                              ]),
                                              _createElementVNode("ul", _hoisted_55, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.flowData.instructions, (item, index) => {
                                                  return (_openBlock(), _createElementBlock("li", _hoisted_56, _toDisplayString(item), 1))
                                                }), 256))
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showTpayWarning)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            _createElementVNode("div", _hoisted_58, [
                                              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "payments-block__tbank-warning-icon" }, "i", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('invoice.tpay-warning.title')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_59, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('invoice.tpay-warning.line-1')), 1),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('invoice.tpay-warning.line-2')), 1),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('invoice.tpay-warning.line-3')), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.currentDeal && _ctx.flowType !== _ctx.FlowType.CARD_ACQUIRING && _ctx.flowType !== _ctx.FlowType.MANUAL_ECOM && _ctx.flowType !== _ctx.FlowType.CARD_ACQUIRING_REDIRECT)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                              _createElementVNode("div", _hoisted_62, [
                                                _cache[27] || (_cache[27] = _createElementVNode("div", {
                                                  class: "payments-block__icon",
                                                  style: {"display":"flex"}
                                                }, [
                                                  _createElementVNode("svg", {
                                                    width: "26",
                                                    height: "24",
                                                    viewBox: "0 0 26 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg"
                                                  }, [
                                                    _createElementVNode("path", {
                                                      "fill-rule": "evenodd",
                                                      "clip-rule": "evenodd",
                                                      d: "M10.5759 1.49171C11.6527 -0.375491 14.3471 -0.375491 15.4239 1.49171L25.4719 18.8917C26.5487 20.7589 25.1999 23.0917 23.0463 23.0917H2.95188C0.796679 23.0917 -0.550521 20.7589 0.527879 18.8917L10.5759 1.49171ZM12.9999 5.49971C13.3181 5.49971 13.6234 5.62614 13.8484 5.85118C14.0735 6.07622 14.1999 6.38145 14.1999 6.69971V12.2997C14.1999 12.618 14.0735 12.9232 13.8484 13.1482C13.6234 13.3733 13.3181 13.4997 12.9999 13.4997C12.6816 13.4997 12.3764 13.3733 12.1514 13.1482C11.9263 12.9232 11.7999 12.618 11.7999 12.2997V6.69971C11.7999 6.38145 11.9263 6.07622 12.1514 5.85118C12.3764 5.62614 12.6816 5.49971 12.9999 5.49971ZM12.9999 19.8997C13.4242 19.8997 13.8312 19.7311 14.1313 19.4311C14.4313 19.131 14.5999 18.7241 14.5999 18.2997C14.5999 17.8754 14.4313 17.4684 14.1313 17.1683C13.8312 16.8683 13.4242 16.6997 12.9999 16.6997C12.5755 16.6997 12.1686 16.8683 11.8685 17.1683C11.5685 17.4684 11.3999 17.8754 11.3999 18.2997C11.3999 18.7241 11.5685 19.131 11.8685 19.4311C12.1686 19.7311 12.5755 19.8997 12.9999 19.8997Z",
                                                      fill: "#FF4747"
                                                    })
                                                  ])
                                                ], -1)),
                                                _createElementVNode("h3", _hoisted_63, [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('invoice.transfer-attention')) + " ", 1),
                                                  (_ctx.currentDeal.isSumChanged)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('invoice.transfer-attention-sum-changed')), 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("ul", _hoisted_65, [
                                                _createElementVNode("li", _hoisted_66, _toDisplayString(_ctx.$t('invoice.transfer-disclaimer-line-1')), 1),
                                                _createElementVNode("li", _hoisted_67, _toDisplayString(_ctx.$t('invoice.transfer-disclaimer-line-2')), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('invoice.transfer-disclaimer-line-attention')), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.receiptPdfRequired && _ctx.currentDeal)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                          _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("div", _hoisted_71, [
                                              _createElementVNode("h3", _hoisted_72, _toDisplayString(_ctx.$t('invoice.receipt-pdf.title')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('invoice.receipt-pdf.text')), 1),
                                            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('invoice.receipt-pdf.attention')), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.receiptPdfRequired && _ctx.currentDeal)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                          (_ctx.receiptFile === null)
                                            ? (_openBlock(), _createElementBlock("form", _mergeProps({
                                                key: 0,
                                                class: "download-form"
                                              }, _ctx.receiptDropzone.getRootProps()), [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["download-form__container download-form__container--payments", {'download-form__container--fail': _ctx.receiptError !== ''}])
                                                }, [
                                                  _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.receiptDropzone.getInputProps())), null, 16),
                                                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('invoice.receipt-pdf.select')), 1),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
                                                    class: "btn btn--accept download-form__btn"
                                                  }, _toDisplayString(_ctx.$t('invoice.receipt-pdf.upload')), 1)
                                                ], 2)
                                              ], 16))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('invoice.receipt-pdf.attached')) + ": " + _toDisplayString(_ctx.receiptFile.name), 1),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn payments-page__close",
                                                  onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeReceipt && _ctx.removeReceipt(...args)), ["prevent"]))
                                                }, _toDisplayString(_ctx.$t('invoice.receipt-pdf.remove')), 1)
                                              ])),
                                          (_ctx.receiptError)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_ctx.receiptError), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.showTransactionIdField)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("label", _hoisted_82, [
                                              _createTextVNode(_toDisplayString(_ctx.$t('invoice.transaction-id-label')) + " ", 1),
                                              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "transaction-field__required" }, "*", -1))
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.transactionId) = $event)),
                                              type: "text",
                                              class: _normalizeClass(["transaction-field__input", {'transaction-field__input--error': _ctx.transactionIdError}]),
                                              placeholder: _ctx.$t('invoice.transaction-id-placeholder'),
                                              onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.transactionIdError = ''))
                                            }, null, 42, _hoisted_83), [
                                              [_vModelText, _ctx.transactionId]
                                            ]),
                                            (_ctx.transactionIdError)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.transactionIdError), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["payments-page__controls", {'payments-page__controls--center': _ctx.receiptPdfRequired}])
                                    }, [
                                      (!_ctx.receiptPdfRequired)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "btn payments-page__close",
                                            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
                                          }, _toDisplayString(_ctx.locale === 'ru' ? _ctx.$t('invoice.cancel-transfer') : _ctx.$t('invoice.return-to-merchant')), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.flowType !== _ctx.FlowType.CARD_ACQUIRING && _ctx.flowType !== _ctx.FlowType.MANUAL_ECOM && _ctx.flowType !== _ctx.FlowType.CARD_ACQUIRING_REDIRECT)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "btn btn--accept",
                                            type: "button",
                                            onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmTransfer && _ctx.confirmTransfer(...args)), ["prevent"]))
                                          }, [
                                            _cache[29] || (_cache[29] = _createElementVNode("svg", {
                                              width: "12",
                                              height: "10",
                                              viewBox: "0 0 12 10",
                                              fill: "none",
                                              xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                              _createElementVNode("path", {
                                                d: "M11.2044 1.6485L4.74285 9.34081C4.67197 9.42524 4.58377 9.49344 4.48423 9.5408C4.3847 9.58817 4.27614 9.61358 4.16592 9.61533H4.15294C4.04512 9.61529 3.93852 9.59259 3.84004 9.54869C3.74156 9.5048 3.65341 9.44069 3.58131 9.36052L0.812078 6.2836C0.741749 6.20901 0.68704 6.12111 0.651168 6.02507C0.615295 5.92903 0.598982 5.82679 0.603186 5.72436C0.607391 5.62193 0.632028 5.52137 0.675651 5.42859C0.719274 5.33581 0.781003 5.2527 0.857208 5.18412C0.933414 5.11554 1.02256 5.06289 1.1194 5.02925C1.21625 4.99562 1.31884 4.98168 1.42115 4.98826C1.52346 4.99484 1.62342 5.02181 1.71515 5.06757C1.80689 5.11334 1.88856 5.17698 1.95535 5.25475L4.13275 7.67399L10.0265 0.659081C10.1587 0.506234 10.3457 0.411551 10.5472 0.395499C10.7486 0.379446 10.9483 0.443313 11.1031 0.573295C11.2578 0.703277 11.3552 0.888932 11.3741 1.09013C11.3931 1.29133 11.3321 1.4919 11.2044 1.6485Z",
                                                fill: "#F7F9FC"
                                              })
                                            ], -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.receiptPdfRequired ? _ctx.$t('invoice.receipt-pdf.i-paid') : _ctx.$t('invoice.confirm-transfer')), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2)
                                  ]))
                                : (_openBlock(), _createBlock(_component_InvoiceStateInfo, {
                                    key: 2,
                                    invoice: _ctx.invoice,
                                    currentDeal: _ctx.currentDeal,
                                    waitingForRequisites: _ctx.waitingForRequisites
                                  }, null, 8, ["invoice", "currentDeal", "waitingForRequisites"]))
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass([{'visible': !!_ctx.copyHintTimeout}, "copy-container"])
                      }, _toDisplayString(_ctx.$t('invoice.tooltip.copied')) + ": " + _toDisplayString(_ctx.copyValue), 3)
                    ]))
}